<template>
  <section class="about-me editorial-section" id="about-me">
    <div class="section-kicker"><span>On the record</span><span>01</span></div>
    <div class="section-title"><p>Subject profile</p>
      <h2>Built on practical engineering and persistent curiosity.</h2>
    </div>
    <div class="about-copy">
      <p>I build reliable software and solve complex technical problems. My work connects practical engineering with a curiosity for how systems operate, improve, and stay secure.</p>
      <p>Across full-stack development, infrastructure, and Linux, I have learned that good software is more than a polished interface. It is the carefully considered system beneath it.</p>
      <p class="about-note">Current direction <strong>Cybersecurity, networking, Linux security, and penetration testing.</strong></p>
    </div>
  </section>
</template>

<script>

export default {
  name: "AboutMe",
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
  },
  mounted() {
  }
}

</script>
